export function useExtractOralAnswer() {
    function cleanMarkdownText(text: string): string {
        // Remove bold markers **word**
        text = text.replace(/\*\*([^*]+)\*\*/g, '$1');

        // Remove italic markers *word* or _word_
        text = text.replace(/[*_]([^*_]+)[*_]/g, '$1');

        // Remove links [text](url)
        text = text.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');

        // Remove code blocks `code`
        text = text.replace(/`([^`]+)`/g, '$1');

        // Remove extra whitespace
        text = text.replace(/\s+/g, ' ');

        // Remove special characters but keep basic punctuation
        text = text.replace(/[^a-zA-Z0-9\s.,!?'"-]/g, '');

        return text.trim();
    }

    function extractAnswerText(modelAnswer: string): string {
        const pattern = /\*\*答案:\*\*(.*?)(?=\*\*助记:\*\*)/s;
        const match = modelAnswer.match(pattern);

        if (match) {
            // Get the matched text (group 1) and trim whitespace
            const answer = match[1].trim();
            return cleanMarkdownText(answer);
        }

        return "";
    }


    return {
        extractAnswerText
    }
}